export const CELL_WIDTH = 25;
export const ROW_HEIGHT = 36;
export const TIMELINE_HEIGHT = 165;
export const LABEL_COLUMN_WIDTH = 120;
export const RULER_HEADER_HEIGHT = 45;
export const RULER_EDGE_PADDING = 10;
export const MAJOR_TICK_INTERVAL = 10;
export const MINOR_TICKS_PER_MAJOR = 4;
export const FRAME_AUTOSCROLL_BUFFER_FRAMES = 4;
export const RULER_TICK_KIND = ({
  MAJOR: 'major',
  MINOR: 'minor'
} as const);
export const FRAME_LABEL_SUFFIX = 'f';
export const TIMELINE_ROW_KIND = ({
  ANNOTATION: 'annotation',
  ATTRIBUTE: 'attribute',
  RELATIONSHIP: 'relationship'
} as const);
export const ROW_EXPAND_STATE = ({
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded'
} as const);
export const SPAN_EDGE = ({
  START: 'start',
  END: 'end'
} as const);
export const TIMELINE_EVENT = ({
  POINTER_DOWN: 'timeline-pointer-down',
  POINTER_MOVE: 'timeline-pointer-move',
  POINTER_UP: 'timeline-pointer-up',
  POINTER_ENTER: 'timeline-pointer-enter',
  POINTER_LEAVE: 'timeline-pointer-leave',
  DRAG_START: 'timeline-drag-start',
  DRAG: 'timeline-drag',
  DRAG_END: 'timeline-drag-end',
  DOUBLE_CLICK: 'timeline-double-click',
  RIGHT_CLICK: 'timeline-right-click'
} as const);
export const TIMELINE_DRAG_ATTR = 'data-timeline-drag';
export const MARKER_CURSOR = ({
  IDLE: 'grab',
  DRAGGING: 'grabbing'
} as const);
export const SPAN_POSITION = ({
  SINGLE: 'single',
  START: 'start',
  MIDDLE: 'middle',
  END: 'end'
} as const);
export const ANNOTATION_TINT_OPACITY = 0.2;
export const DIAMOND_SIZE = 11;
export const ROW_ID_SEPARATOR = ':';
export const RELATIONSHIP_ROW_VARIANT = ({
  SAVED: 'saved',
  DRAFT: 'draft'
} as const);